var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row m-t-5 row-center"},[_c('div',{staticClass:"column large-8 medium-10 small-11 xsmall-12"},[_c('div',{staticClass:"m-t-4"},[(_vm.heading)?_c('h2',{staticClass:"f-s-8 c-primary m-t-6"},[_vm._v(_vm._s(_vm.heading))]):_vm._e(),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.text)}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }